import { render, staticRenderFns } from "./account.vue?vue&type=template&id=3d1f5ff5&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=3d1f5ff5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f5ff5",
  null
  
)

export default component.exports